import React from 'react';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Units Sold top entity chart with single dropdown
 */
const AtlasV2UnitsSoldDropdownTopEntityChart = () => {
  const mainEntityType = useMainEntityType();
  return (
    <AtlasV2DropdownMetricColumnChart
      indexName="sales"
      fieldName="unitsSold"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },

        {
          id: 'parentBrandId',
          label: 'Manufacturer'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(mainEntityType))}
      titlePrefix="Units Sold by"
    />
  );
};
export default AtlasV2UnitsSoldDropdownTopEntityChart;
